























































import Vue from 'vue';
import AppSystemResourceViewModel from '../../../../services/viewModel/resource/AppSystemResourceViewModel';
import ContactIdMappingResourceViewModel from '../../../../services/viewModel/resource/ContactIdMappingResourceViewModel';

export default Vue.extend({
  auth: true,
  role: ['admin', 'hostadmin'],
  layout: 'layout-hostadmin',
  data: () => ({
    isLoading: false,
    isRefreshing: false,
    successMessage: undefined as any,
    requestError: undefined as any,
    appSystem: new AppSystemResourceViewModel() as AppSystemResourceViewModel,
    contactIdMappingDetail: {} as ContactIdMappingResourceViewModel,
    id: Number as unknown | undefined,
  }),
  computed: {
    lastUpdated() {
      return this.$format.localDateAndTime(this.contactIdMappingDetail.modified ?? this.contactIdMappingDetail.created!);
    },
    previousContactDataJsonHtml() {
      return JSON.stringifyToHTML(this.contactIdMappingDetail?.previousContactData);
    },
    currentContactDataJsonHtml() {
      return JSON.stringifyToHTML(this.contactIdMappingDetail?.currentContactData);
    },
  },
  async mounted() {
    this.isLoading = true;
    try {
      const { id } = this.$router.currentRoute.params;
      this.id = id;
      const response = await this.$service.api.core.contactIdMappings.getContactIdMappingById(id as any);
      this.contactIdMappingDetail = response;
      const responseAppSystems = await this.$service.api.core.appSystem.getAppSystems();
      const appSystems = responseAppSystems.items;
      this.appSystem = appSystems.find((a) => a.id === this.contactIdMappingDetail.foreignAppSystemId) ?? new AppSystemResourceViewModel();
    } catch (error: any) {
      this.requestError = error;
    }
    this.isLoading = false;
  },
  methods: {
    async updateContactIdMapping() {
      this.isRefreshing = true;
      try {
        const { id } = this.contactIdMappingDetail;
        const integrationId = await this.$service.api.core.processes.updateContactIdMapping(id!);
        this.successMessage = `Successfully Queued: IntegrationLog Id=${integrationId?.toString()}`;
      } catch (error: any) {
        this.requestError = error;
        Vue.$log.error(error);
      }
      this.isRefreshing = false;
    },
    back() {
      this.$router.back();
    },
  },
});
